import Types from "../actions/types";
import * as fromOrganisations from "features/organisations";
import {
	onJobSafetyAnalysisListReceive,
	onJobSafetyAnalysisListFailed,
} from "../actions";
import { ofType } from "redux-observable";
import { mergeMap, catchError, filter } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { authHeaders, tokenExists, getOrganisationBaseUrl } from "frame";

export const jsaListEffect = (action$, state$) =>
	action$.pipe(
		ofType(
			Types.JOB_SAFETY_ANALYSIS_LIST_REQUESTED,
			fromOrganisations.ORGANISATION_FETCH_SUCCESS,
			fromOrganisations.ORGANISATIONS_CURRENT_ORGANISATION_CHANGED
		),
		filter(() => tokenExists()),
		filter(() => !!state$.value.organisations.currentOrganisation),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(() =>
			ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/job-safety-analysis/paged`,
					{
						page: 1,
						pageSize: 5000,
						orderBy: "createdAt",
						ascending: false,
					},
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							onJobSafetyAnalysisListReceive(
								ajaxResponse.response
							)
						)
					),
					catchError((error) =>
						of(onJobSafetyAnalysisListFailed(error))
					)
				)
		)
	);

export const jsaPagedListEffect = (action$, state$) =>
	action$.pipe(
		ofType(Types.JOB_SAFETY_ANALYSIS_PAGED_LIST_REQUESTED),
		filter(() => state$.value.organisations.currentOrganisation),
		filter(() => tokenExists()),
		filter(() => state$.value.queue.hasNetwork),
		mergeMap(({ payload }) => {
			const pagingParams = payload;
			return ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/job-safety-analysis/paged`,
					pagingParams,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) =>
						of(
							onJobSafetyAnalysisListReceive(
								ajaxResponse.response
							)
						)
					),
					catchError((error) =>
						of(onJobSafetyAnalysisListFailed(error))
					)
				);
		})
	);

